//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('accounts', {
//        templateUrl: 'views/components/views/accounts/accounts.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['stateService', 'utilityService', 'accountsService', 'logisticService', 'languageService', 'ttGridFactory', 'rememberService', function (stateService, utilityService, accountsService, logisticService, languageService, ttGridFactory, rememberService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;

//            let variableNames = {
//                businessco_no: '',
//                language_id: '',
//                show_not_active: ''
//            };

//            vm.model = {
//                setting: {},
//                selectListCompanies: [],
//                selectListLanguages: [],
//                gridReady: false
//            };

//            vm.grid = new ttGridFactory({
//                rememberId: 'w_accounts_grid',
//                kendo: {
//                    height: '100%',
//                    sortable: true,
//                    aggregate: true,
//                    pager: false,
//                    selectable: false,
//                    filterable: false
//                }
//            });
            
//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALLS

//            async function loadSetting() {
//                vm.model.setting = (await accountsService.getAccounts())[0];

//                return loadGrid();
//            }

//            async function loadCompanies() {
//                vm.model.selectListCompanies = await logisticService.listCompanies();
//            }

//            async function loadLanguages() {
//                vm.model.selectListLanguages = await languageService.list();
//            };

//            // #endregion LOAD PROCEDURE FUNCTION CALLS

//            // #region GRID PROCEDURE FUNCTION CALLS

//            async function loadGrid() {
//                vm.grid.dataTask.loadData = {
//                    method: 2939,
//                    parameters: vm.model.setting
//                };

//                vm.model.gridReady = true;

//                if (vm.grid.gridfunc !== null) vm.grid.gridfunc.read();
//            }

//            // #endregion GRID PROCEDURE FUNCTION CALLS

//            // #region REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            function rememberFunc(id) {
//                Object.keys(variableNames).forEach((key) => {
//                    variableNames[key] = 'w_' + stateService.getCurrentName() + '.' + key;
//                });

//                if (utilityService.validateParmsValue(variableNames[id]) !== true) return;

//                let variableValue = null;

//                switch (id) {
//                    case 'businessco_no':
//                    case 'language_id':
//                    case 'show_not_active':
//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        variableValue = vm.model.setting[id];
//                        break;
//                    default:
//                        break;
//                }

//                return rememberService.remember(variableNames[id], variableValue);
//            }

//		    // #endregion REMEMBER VALUE MULTI PROCEDURE FUNCTION CALLS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            // #region FIELD CHANGE MULTI FUNCTIONS

//            vm.onChanged = function (value, id) {
//                switch (id) {
//                    case 'businessco_no':
//                    case 'language_id':
//                    case 'show_not_active':
//                        if (utilityService.validateWatchValue(value, vm.model.setting[id]) !== true) return;

//                        vm.model.setting[id] = value;

//                        if (utilityService.validateParmsValue(vm.model.setting[id], true) !== true) return;

//                        return Promise.all([
//                            rememberFunc(id)
//                        ]).then(() => {
//                            loadGrid();
//                            Promise.resolve();
//                        });

//                        return Promise;
//                        break;
//                    default:
//                        utilityService.setValueToVariable(value);
//                        break;
//                }
//            };

//            // #endregion FIELD CHANGE MULTI FUNCTIONS

//            // #region MULTI DIRECTION BUTTON FUNCTIONS

//            vm.goToFunc = function (state, e) {
//                function go(parms) {
//                    if (e?.ctrlKey) {
//                        stateService.newTab(state, parms);
//                    } else {
//                        stateService.go(state, parms);
//                    }
//                }

//                switch (state) {
//                    case 'account':
//                        go({
//                            account_no: '0',
//                            businessco_no: vm.model.setting.businessco_no
//                        });
//                        break;
//                    default:
//                        break;
//                }
//            };

//		    // #endregion MULTI DIRECTION BUTTON FUNCTIONS

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadSetting();
//                loadCompanies();
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
